export default (event, app) => {
  console.log('[OrderShouldBeReloaded] Reloading order.', event)

  app.$store.dispatch('order/loadOrder', { orderId: event.id, orderToken: event.token })
    .then(() => {
      app.$store.commit('order/setPromotionsAreChecking', false)
      console.log('[OrderShouldBeReloaded] Order has been reloaded.', event)
    })
    .catch(err => {
      app.$store.commit('order/setPromotionsAreChecking', false)
      console.error('[OrderShouldBeReloaded] Unable to reload order, reloading page.', err)
      location.reload()
    })
}
